import { ContestParticipationDto } from '../../../../interfaces/dtos/ContestParticipationDto';
import { ContestParticipation } from '../../../../interfaces/ContestParticipation';

export default function transformContest(data: ContestParticipationDto): ContestParticipation {
  return {
    isSubscribed: data.isSubscribed,
    isPostponed: data.isPostponed,
  };
}
